/* Mega-menu dropdown position fix.
   The CSS uses position: fixed + top: auto, which different browsers
   resolve inconsistently once the page has been scrolled. We force it
   to the actual viewport-bottom of the header bar each time a dropdown
   opens (and on resize while open).
*/
(function () {
  function setTop(content) {
    var details = content.closest('details.mega-menu');
    if (!details) return;
    // Anchor on the actual nav-row element (the one visually sitting at
    // the top), not the outer wrapper which can include extra rows.
    var anchor = details.closest('.header--middle-center')
      || details.closest('header.header')
      || details.closest('.header-wrapper');
    if (!anchor) return;
    var rect = anchor.getBoundingClientRect();
    content.style.setProperty('top', rect.bottom + 'px', 'important');
  }

  document.addEventListener('toggle', function (e) {
    var target = e.target;
    if (!target || !target.matches || !target.matches('details.mega-menu')) return;
    if (!target.open) return;
    var content = target.querySelector('.mega-menu__content');
    if (content) setTop(content);
  }, true);

  // Recompute on resize while a mega menu is open.
  window.addEventListener('resize', function () {
    var openMenus = document.querySelectorAll('details.mega-menu[open] .mega-menu__content');
    openMenus.forEach(setTop);
  });

  // Recompute on scroll while a mega menu is open (header height could
  // change due to sticky-bar collapse, etc.).
  window.addEventListener('scroll', function () {
    var openMenus = document.querySelectorAll('details.mega-menu[open] .mega-menu__content');
    openMenus.forEach(setTop);
  }, { passive: true });
})();
